/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import proptypes from 'prop-types';
const { shape, string, bool, number, arrayOf } = proptypes;
import {
  Typography
} from '@one-thd/sui-atomic-components';
import { WarningFilled, InfoFilled } from '@one-thd/sui-icons';
import { InformationIcon } from '../../../../pod/helpers/icon-utils';
import { isMobile, isDesktop } from '../../../helper/utils';

const DefaultBOPISDetails = ({
  fulfillment,
  quantity,
  bossFulfillment,
  channel,
  pricing,
  bopisMinimumThreshold,
  bopisMinimumThresholdStores,
  isCartTiles,
}) => {
  const localStoreLocation = (fulfillment?.locations || []).find((location) => location.isAnchor);
  const isBopisThresholdStore = bopisMinimumThresholdStores?.split(',').indexOf(localStoreLocation?.locationId) !== -1;
  const showMinimumThresholdMessage = (quantity * pricing?.value) < bopisMinimumThreshold;

  const renderBossToolTip = () => (
    <div className="sui-flex sui-pt-4">
      <span className="sui-pl-1 sui-pr-1">{InformationIcon}</span>
      <Typography variant="body-base">
        Need more? Just enter the quantity you need and we will ship it to
        <span className="sui-font-bold"> {localStoreLocation?.storeName} </span>
        for FREE Pickup.
      </Typography>
    </div>
  );

  return localStoreLocation?.inventory?.isInStock && (
    <div>
      <div>
        {
          isCartTiles && fulfillment?.isBossDominant && (
            <span className="sui-flex sui-pt-2">
              <div className="sui-pr-1 sui-pt-1">
                <InfoFilled
                  size="regular"
                  style={{ color: '#499992' }}
                />
              </div>
              <Typography variant="body-base">
                {'Need more? Just enter the quantity you need and we will ship it to '}
                <span className="sui-font-bold">
                  {localStoreLocation?.storeName}
                </span>
                {' for FREE Pickup.'}
              </Typography>
            </span>
          )
        }
        {!isCartTiles && bossFulfillment && (isMobile(channel) || isDesktop(channel)) && renderBossToolTip()}
      </div>
      {showMinimumThresholdMessage && isBopisThresholdStore && (
        <div className="sui-pt-1">
          <div className="sui-flex sui-flex-wrap">
            <WarningFilled color="warning" />
            <Typography variant="body-base">
              <div className="sui-pl-2">
                <span>There&apos;s a ${bopisMinimumThreshold} minimum purchase for pickup.</span>
              </div>
            </Typography>
          </div>
        </div>
      )}
    </div>
  );
};

DefaultBOPISDetails.propTypes = {
  quantity: number,
  channel: string,
  bossFulfillment: shape({
    type: string,
    locations: arrayOf(shape({
      isAnchor: bool,
      inventory: shape({
        quantity: number,
        isInStock: bool,
        isLimitedQuantity: bool,
        isBackordered: bool
      })
    }))
  }),
  fulfillment: shape({
    type: string,
    locations: arrayOf(shape({
      isAnchor: bool,
      inventory: shape({
        quantity: number,
        isInStock: bool,
        isLimitedQuantity: bool,
        isBackordered: bool
      })
    }))
  }).isRequired,
  pricing: shape({
    value: number
  }).isRequired,
  bopisMinimumThreshold: number,
  bopisMinimumThresholdStores: string,
  isCartTiles: bool
};

DefaultBOPISDetails.defaultProps = {
  quantity: 1,
  bossFulfillment: null,
  channel: 'desktop',
  bopisMinimumThreshold: null,
  bopisMinimumThresholdStores: null,
  isCartTiles: false
};

export { DefaultBOPISDetails };